import { Component, inject, signal } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';
import { dialogRiseWithLeaveAnimation } from '../../../animations/pricing-animations';
import { BonusSurveyStepperComponent } from './components/bonus-survey-stepper.component';
import { SurveyDto } from '../../../../api/models/fraud.models';
import { BonusSurveyService } from '../../../services/bonus-survey.service';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

export interface BonusSurveyDialogData {
  surveyId: number;
}

@Component({
  selector: 'app-dialog-bonus-survey',
  imports: [
    MatIcon,
    MatDialogClose,
    BonusSurveyStepperComponent,
    MatProgressSpinner
  ],
  templateUrl: './dialog-bonus-survey.component.html',
  styleUrl: './dialog-bonus-survey.component.scss',
  animations: [dialogRiseWithLeaveAnimation],
})
export class DialogBonusSurveyComponent {
  readonly data: BonusSurveyDialogData = inject(MAT_DIALOG_DATA);
  private readonly _bonusSurveyService = inject(BonusSurveyService);

  readonly survey = signal<SurveyDto | null>(null);
  readonly rewardAmount = signal<string | number>(this._bonusSurveyService.getFallbackRewardAmount());
  readonly isLoading = signal(true);

  onSurveyLoaded(survey: SurveyDto): void {
    this.survey.set(survey);
    this.rewardAmount.set(this._bonusSurveyService.resolveDisplayRewardAmount(survey));
  }

  onSurveyLoadFinished(): void {
    this.isLoading.set(false);
  }
}
